import { ITheme } from "../../utils/theme";

export const containerStyle = {
  background: (theme: ITheme) => theme.palette.common.white,
  paddingRight: 1,
  paddingLeft: 1,
}

export const shiftDetailContainerStyle = {
  display: "flex"
}

export const linkStyle = {
  fontWeight: "bold",
  textDecoration: "underline",
  color: (theme: ITheme) => theme.palette.common.black,
}

export const linkSectionStyle = {
  margin: "5px 0",
}

export const vancouerIslandLinkSectionStyle = {
  ...linkSectionStyle,
  justifyContent: { xs: "start", sm: "end" }
}

export const tabStyle = {
  minHeight: "30px",
  textTransform: "none",
  fontWeight: "bold",
  background: (theme: ITheme) => theme.palette.grey[600],
  '&.Mui-selected': {
    color: (theme: ITheme) => theme.palette.blue[650],
    background: (theme: ITheme) => theme.palette.common.white,
  }
}

export const tabsStyle = {
  minHeight: "30px",
  marginTop: 1,
}

export const selectStyle = {
  margin: "8px 2px",
  "&.MuiOutlinedInput-root": {
    "& .MuiSelect-select": {
      padding: "10px 15px",
    }
  }
}

export const hideScrollBar = {
  overflow: "auto",
  marginBottom: "2",
  WebkitOverflowscrolling: "touch",
  "&::-webkit-scrollbar": {
    display: "none"
  },
  msOverflowStyle: "none"
}